import { JsonObject } from '@bufbuild/protobuf';
import { BreachInfo } from '@q6cyber/proto2es/generated/breach';

import { FormControl, FormGroup, Validators } from '@angular/forms';

import { RouterOutput } from '../../../utils';
import { AlphaNumericWithSeparators } from '../validations';
import { CorruptedData } from './generic-data.interface';

export interface BreachInfoListResponse
  extends
    Omit<RouterOutput['breachInfo']['list']['edges'][0], 'node'>,
    CorruptedData {
  node: BreachInfo | null;
}

export const DEFAULT_BREACH_INFO = new BreachInfo({}).toJson({
  emitDefaultValues: true,
}) as JsonObject;

export const breachInfoForm = () => {
  const form = new FormGroup({
    id: new FormControl('', [
      Validators.required,
      Validators.pattern(AlphaNumericWithSeparators),
      Validators.maxLength(10),
    ]),
    title: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    breachDate: new FormControl(null),
    description: new FormControl(''),
    spanishDescription: new FormControl(''),
    conciseDescription: new FormControl(''),
    verified: new FormControl(false),
    retired: new FormControl(false),
    fabricated: new FormControl(false),
    spamList: new FormControl(false),
    sensitive: new FormControl(false),
    comboList: new FormControl(false),
    dataClasses: new FormControl([]),
    pwnCount: new FormControl(null),
    url: new FormControl(null),
    logoPath: new FormControl(null),
    stealerLog: new FormControl(false),
    subscriptionFree: new FormControl(false),
    q6BreachNames: new FormControl([]),
    addedDate: new FormControl(null),
    modifiedDate: new FormControl(null),
  });

  return form;
};
